import React from "react";

import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  TextField,
} from "@mui/material";

interface SearchFormProps {
  orgName: string;
  roleId: string;
  errorMessage: string;
  overwriteExisting: boolean;
  onSearch: () => void;
  onChange: (changes: {
    orgName?: string;
    roleId?: string;
    overwriteExisting?: boolean;
  }) => void;
}

export const SearchForm: React.FC<SearchFormProps> = ({
  orgName,
  roleId,
  errorMessage,
  overwriteExisting,
  onSearch,
  onChange,
}) => {
  const isSearchDisabled = !orgName && !roleId;

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    onSearch();
  };

  return (
    <Box
      component="form"
      onSubmit={handleSubmit}
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
      }}
    >
      <TextField
        label="Organization Name"
        value={orgName}
        onChange={(e) => onChange({ orgName: e.target.value })}
        fullWidth
        error={Boolean(errorMessage)}
      />

      <TextField
        label="Role ID"
        value={roleId}
        onChange={(e) => onChange({ roleId: e.target.value })}
        fullWidth
        error={Boolean(errorMessage)}
        helperText={errorMessage}
      />

      <FormControlLabel
        control={
          <Checkbox
            checked={overwriteExisting}
            onChange={(e) => onChange({ overwriteExisting: e.target.checked })}
          />
        }
        label="Overwrite if course exists in target organization"
      />

      <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
        <Button type="submit" variant="contained" disabled={isSearchDisabled}>
          Search
        </Button>
      </Box>
    </Box>
  );
};
